export default {
  title: 'Вы недавно смотрели',
} as const;
